import {
  CIRCLE_CENTER,
  CIRCLE_RADIUS,
  CIRCLE_ROTATION_OFFSET,
  STROKE_WIDTH,
  mainClass,
} from './constants'

interface CircularProgressProps {
  circumference: number
  strokeDashoffset: number
}

export const CircularProgress = ({
  circumference,
  strokeDashoffset,
}: CircularProgressProps) => {
  return (
    <svg className={`${mainClass}__svg`} viewBox="0 0 100 100">
      <circle
        className={`${mainClass}__circle-bg`}
        cx={CIRCLE_CENTER}
        cy={CIRCLE_CENTER}
        r={CIRCLE_RADIUS}
        fill="none"
        stroke="#2a2a2a"
        strokeWidth={STROKE_WIDTH}
      />
      <circle
        className={`${mainClass}__circle-progress`}
        cx={CIRCLE_CENTER}
        cy={CIRCLE_CENTER}
        r={CIRCLE_RADIUS}
        fill="none"
        stroke="#fff"
        strokeWidth={STROKE_WIDTH}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        transform={`rotate(${CIRCLE_ROTATION_OFFSET} ${CIRCLE_CENTER} ${CIRCLE_CENTER})`}
      />
    </svg>
  )
}
